<app-page-shell [title]="'no_permission_title' | translate">
  <div class="flex flex-col items-center justify-center p-8 text-center h-full min-h-[400px]">
    <div class="w-64 h-64 mb-6">
      <ng-lottie [options]="options"></ng-lottie>
    </div>
    
    <p class="text-slate-500 max-w-md">
      {{ (planReason ? 'plan_module_not_included' : 'no_permission_desc') | translate }}
    </p>
  </div>
</app-page-shell>
